// 地区
import * as type from "../mutation-types"
const state = {
  data:window.localStorage.getItem("region") || ""
}

const getters = {
  getRegion:state=>state.data
}

const mutations = {
  [type.USER_OUT_LOGIN](state){
    state.data = null
  }
}

const actions = {
  onUse(response){
    window.localStorage.setItem("region",response)
  },
  outLogin({commit}){
    commit(type.USER_OUT_LOGIN)
    window.localStorage.removeItem("region")
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}